"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var processProperties_1 = __importDefault(require("./helpers/processProperties"));
var validate_1 = __importDefault(require("../validate"));
function validateFBTField(_ref) {
  var field = _ref.field,
    formPayload = _ref.formPayload,
    context = _ref.context,
    value = _ref.value;
  var fieldSlug = field.slug;
  var validators = field.validators || [];
  var fieldValue = value ? value : formPayload[fieldSlug];
  var filteredContextValidations = validators.filter(function (_ref2) {
    var validationContext = _ref2.context;
    var shouldUseFieldContext = !!validationContext && typeof validationContext === 'string';
    var isSameContext = validationContext === context;
    var bypassValidator = shouldUseFieldContext && !isSameContext;
    return !bypassValidator;
  });
  var validationsResults = filteredContextValidations.map(function (_ref3) {
    var type = _ref3.type,
      properties = _ref3.properties;
    var processedProperties = !!properties ? (0, processProperties_1.default)(properties, formPayload) : properties;
    var validation = (0, validate_1.default)(type, fieldValue, processedProperties);
    return validation;
  });
  var invalidValidations = validationsResults.filter(function (result) {
    return !result.isValid;
  });
  var isValid = invalidValidations.length === 0;
  return {
    isValid: isValid,
    validationsResults: validationsResults,
    invalidValidations: invalidValidations
  };
}
exports.default = validateFBTField;